import { useTranslation } from "@msuite/ui/localization";
import type { Enums } from "@msuite/utils/types";
import { INCOMING_INVOICE_KIND_LABEL } from "./incoming-invoice-kind-labels";

/** Props Interface */
interface IncomingInvoiceKindLabelProps {
	kind: Enums<"incomingInvoiceKind">;
}

export function IncomingInvoiceKindLabel({ kind }: IncomingInvoiceKindLabelProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return <span>{t(INCOMING_INVOICE_KIND_LABEL[kind])}</span>;
}
